require('bootstrap/js/src/util');
require('bootstrap/js/src/alert');
// require('bootstrap/js/src/button');
// require('bootstrap/js/src/carousel');
require('bootstrap/js/src/collapse');
require('bootstrap/js/src/dropdown');
require('bootstrap/js/src/modal');
require('bootstrap/js/src/scrollspy');
// require('bootstrap/js/src/tab');
// require('bootstrap/js/src/tooltip');
// require('bootstrap/js/src/popover');
